import { HTTP, authHeader } from './http-service';

class BusinessIntelligenceService {
  search(payload) {
    return HTTP.post(`/BusinessIntelligenceSearch`, payload, { headers: authHeader() }).then(
      (response) => {
        return response.data;
      },
    );
  }

  advancedSearch(payload) {
    return HTTP.post(`/BusinessIntelligenceSearch/advance`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  getById(trustmarkBusinessId) {
    return HTTP.get(`/BusinessIntelligenceSearch/${trustmarkBusinessId}`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  getTrades(trustmarkBusinessId) {
    return HTTP.get(`/BusinessIntelligenceSearch/${trustmarkBusinessId}/trades`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  getBusinessIntelligenceActivityLogs(payload) {
    return HTTP.post(`/BusinessIntelligenceSearch/activity-logs`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }
}

export default new BusinessIntelligenceService();
